<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'setting'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">{{$t('form.identityverification')}}</h1>
						</div>
						<div class="form-container">
							<el-form ref="ruleForm" label-position="left" :model="ruleForm" :rules="rules" label-width="100%">
								<el-form-item :label="$t('form.documenttype')+':'" prop="zjtype">
									<el-select v-model="ruleForm.zjtype" :placeholder="$t('form.documenttype')">
										<el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,index) in typeArr" :key="index"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item :label="$t('form.uploadfrontside')+':'" prop="sfzfront">
									<div class="v-upload-container">
										<div class="v-upload-area" style="position: relative;">
											<input style="width:100%;height:100%;opacity:0;position: absolute;top:0;left:0;z-index: 2;cursor: pointer;" type="file" accept="image/*,application/pdf" @change="onFileChange" />
											<div v-if="!ruleForm.sfzfront" class="upload-placeholder">
												<span>+</span>
											</div>
											<template v-else>
												<template v-if="sfzfrontType == 1">
													<img :src="ruleForm.sfzfront" alt="Uploaded photo" class="uploaded-img" />
												</template>
												<template v-else>
													<div class="v-upload-item">
														<i class="el-icon-document"></i>
														{{sfzfrontName}}
													</div>
												</template>
											</template>
											
										</div>
									</div>
								</el-form-item>
								<el-form-item :label="$t('form.uploadbackside')+':'" prop="sfzback">
									<div class="v-upload-container">
										<div class="v-upload-area" style="position: relative;">
											<input style="width:100%;height:100%;opacity:0;position: absolute;top:0;left:0;z-index: 2;cursor: pointer;" type="file" accept="image/*,application/pdf" @change="onFileChange2" />
											<div v-if="!ruleForm.sfzback" class="upload-placeholder">
												<span>+</span>
											</div>
											<template v-if="sfzbackType == 1">
												<img :src="ruleForm.sfzback" alt="Uploaded photo" class="uploaded-img" />
											</template>
											<template v-else>
												<div class="v-upload-item">
													<i class="el-icon-document"></i>
													{{sfzbackName}}
												</div>
											</template>
										</div>
									</div>
								</el-form-item>
								<el-form-item>
								    <el-button type="primary" @click="submitForm()">{{$t('button.save')}}</el-button>
								    <el-button @click="resetForm()">{{$t('button.reset')}}</el-button>
								</el-form-item>
								
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {uploadFile,querySfType,addIds} from '../../api/home'

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				selectedFile: null,
				ruleForm: {
					zjtype: '',
					sfzfront: '',
					sfzback: '',
				},
				sfzfrontType:1,
				sfzbackType:1,
				sfzfrontName:'',
				sfzbackName:'',
				rules: {
				    zjtype: [
				        { required: true, message: this.$t('tips.requiredocumenttype'), trigger: 'change' }
				    ],
				    sfzfront: [
				        { required: true, message: this.$t('tips.requirefrontsideid'), trigger: 'change' }
				    ],
				    sfzback: [
				        { required: true, message: this.$t('tips.requirebacksideid'), trigger: 'change' }
				    ]
				},
				typeArr:[]
			}
		},
		created() {
			this.getType()
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
			},
			onFileChange(e) {
				this.selectedFile = e.target.files[0];
				this.uploadPhoto(1)
			},
			onFileChange2(e) {
				this.selectedFile = e.target.files[0];
				this.uploadPhoto(2)
			},
			uploadPhoto(type) {
				// 上传到服务器
				const formData = new FormData();
				formData.append('file', this.selectedFile, this.selectedFile.name);
				let file = formData
				var ftype = this.selectedFile.type;
				var fileType = 1;
				if (ftype.includes('application/')) {
					fileType = 2
				}
				const loading = this.$loading({
				    lock: true,
				    text: 'Loading',
				    spinner: 'el-icon-loading',
				    background: 'rgba(0, 0, 0, 0.2)'
				});
				uploadFile(file).then(res => {
					loading.close();
					if (res.code == 200) {
						// 假设接口返回的文件URL在 res.data.url 中
						if(type == 1){
							this.ruleForm.sfzfront = res.url;
							this.sfzfrontType = fileType
							this.sfzfrontName = this.selectedFile.name
						}else{
							this.ruleForm.sfzback = res.url;
							this.sfzbackType = fileType
							this.sfzbackName = this.selectedFile.name
						}
						this.$message.success('Image uploaded successfully');
					} else {
						this.$message.error(res.msg || 'Image upload failed');
					}
				}).catch(err => {
					this.$message.error(err.msg || 'Image upload failed');
				});
			},
			submitForm() {
			    this.$refs.ruleForm.validate((valid) => {
			        if (valid) {
						var that = this
						var params = {
							zjtype:this.ruleForm.zjtype,
							sfzfront:this.ruleForm.sfzfront,
							sfzback:this.ruleForm.sfzback
						}
						addIds(params).then(res => {
							if (res.code == 200) {
								this.$message.success(this.$t('tips.submitsuccess'));
								setTimeout(() => {
									that.openPage('/')
								}, 1000)
							}else{
								this.$message.error(this.$t('tips.submitfail'));
							}
						});
			        } else {
			            return false;
			        }
			    });
			},
			resetForm() {
			    this.$refs.ruleForm.resetFields();
			},
			getType(){
				var that = this
				var params = {}
				querySfType(params).then(res => {
					if (res.code == 200) {
						that.typeArr = res.data
						if(that.typeArr.length > 0){
							that.ruleForm.zjtype = that.typeArr[0].dictValue
						}
					}
				});
			}
		}
	}
</script>

<style scoped>
	.form-container {
		padding: 0 10px;
	}
	.v-upload-container {
		position: relative;
		width: 100px;
		height: 100px;
		border: 2px dashed #eee;
		border-radius: 4px;
		cursor: pointer;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.upload-placeholder {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #999;
		cursor: pointer;
	}

	.v-upload-container .v-upload-area {
		width: 100%;
		height: 100%;
	}

	.uploaded-img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	/deep/ .el-form-item__content {
		margin-left: 0 !important;
	}
	@media (max-width: 768px) {
		.form-container {
			padding: 15px 10px;
		}
	}
	.v-upload-item {
	    color: #606266;
	    display: block;
	    overflow: hidden;
	    padding-left: 4px;
	    text-overflow: ellipsis;
	    transition: color .3s;
	    white-space: nowrap;
	}
	.v-upload-item [class^=el-icon] {
	    height: 100%;
	    margin-right: 7px;
	    color: #909399;
	    line-height: inherit;
	}
</style>
